import axios from 'axios';

const salesApi = {
    async newChat({ name, locale }) {
        const response = await axios.post('/api/v2/sales/chat', { name, locale });
        return response.data;
    },
    async getChatMessages(chatId) {
        const response = await axios.get(`/api/v2/sales/chat/${chatId}/messages`);
        return response.data.response || [];
    },
    async rating(message, rating) {
        const url = `/api/v2/sales/chat/${message.chatId}/message/${message.originalId}/rating/${rating}`;
        const response = await axios.post(url);
        return response.data;
    },
    async postSupportTicket(message, supportTicketRequest) {
        const url = `/api/v2/sales/chat/${message.chatId}/message/${message.originalId}/support_request`;
        const response = await axios.post(url, supportTicketRequest);
        return response.data.response;
    },
};

export default salesApi;
